import { useState } from 'react';
import Box from "@mui/material/Box";
import CreateTL from "./components/createTL";
import ArtistName from "./components/artistName";
import SelectMoj from "./components/selectMoj";
import useUploadContext from "hooks/useUploadContext";
import VolumeKnob from "./components/Knob";
import { Button } from "@mui/material";
import BackRight from "assets/images/backRight.png";
import SaveDraft from "./components/saveDraft/saveDraft";
import BareBandi from "./components/bareBandi/bareBandi";
import BareShow from "components/UploadPage/RightSidebar/BareShow";
import SaveProjectConfirm from "components/UploadPage/RightSidebar/SaveProjectConfirm";
import Loading from "components/shared/Loading";
import axios from 'lib/axios';
import { getItem } from "lib/Storage";
import "./index.scss";
import { useSaveDraft, useSaveFile, useUploadDone, useEditDraft, useSaveTl } from 'hooks/uploadMutations';

const RightSidebar = () => {
  const {
    layers,
    setTempo,
    bareBandiType,
    setBareBandiType,
    layersIsActive,
    time,
    setTime,
    setLayersUpdated,
    bares,
    setBares,
    tempo,
    rightTab,
    setRightTab,
    selectedDraft,
    setSelectedDraft,
    totalTime,
    mutes,
  } = useUploadContext();

  const [loading, setLoading] = useState(false)

  const { mutateAsync: saveDraftAsync } = useSaveDraft();
  const { mutateAsync: saveFileAsync } = useSaveFile();
  const { mutateAsync: uploadDoneAsync } = useUploadDone();
  const { mutateAsync: editDraftAsync } = useEditDraft();
  const { mutateAsync: saveTlAsync } = useSaveTl();

  const allLayerLock = () => {
    return layers.some((layer) => layer?.file && layer.locked);
  };

  const handleBack = () => {
    if (!bareBandiType) {
      if (rightTab === 'saveDraft' || 'bareBandi' || 'createTL') {
        setRightTab(null);
      }
      if (rightTab === 'artistName') {
        setRightTab("createTL");
      }
      if (rightTab === 'selectMoj') {
        setRightTab("artistName");
      }
    }
    else {
      setBareBandiType(null);
    }
  };

  const handleBackFromSaveProject = (i) => {
    setRightTab(null);
    const source = getItem('source');
    if(source && i === 'app') {
      window.location.replace(source)
    }
  };

  const handleManualBareBandi = () => {
    const newBares = [...bares];
    const newBareIndex = newBares.findIndex(bare => bare === time);
    if (newBareIndex !== -1) {
      newBares.splice(newBareIndex, 1);
    } else {
      newBares.push(time);
    }
    const sortedArray = newBares.sort((a, b) => a - b);
    setBares(sortedArray)
  };

  const handleAutoBareBandi = () => {
    if (tempo <= 0) return;
    const duration = (32 / tempo) * 60;
    const fullPartsCount = Math.floor(totalTime / duration);
    let parts = [];
    for (let i = 0; i <= fullPartsCount; i++) {
      parts.push(i * duration);
    }

    parts.push(totalTime);
    setBares(parts);
  };

  const bareNumber = () => {
    let bareIndex = bares.findIndex(bare => bare >= time);
    if (bares[bareIndex] === time) {
      bareIndex++
    }
    return bareIndex;
  };

  const handleSaveDraft = async (data, tl) => {
    try {
      setLoading(true);
      const uploadPromises = layers.map(async (layer, index) => {
        const file = layer?.file;
        const selectedLayer = {
          id: `layer ${index}`,
          fileId: null,
          name: layer?.title ? layer.title : `layer ${index}`,
          active: !mutes[index],
          isDecorative: false,
          layerNumber: index,
          layerPosition: index,
        };
  
        if (file) {

          const fileData = {
            filename: file.name,
            filesize: file.size,
            metadata: {
              name: file.name,
              format: file.name.split('.').pop(),
              lastModified: file.lastModified,
              created: file.created,
              anyOtherFields: "",
              length: file.length,
              type: file.type,
              size: file.size
            }
          };
          
          const {fileId, url} = await saveFileAsync(fileData);
          const { statusText } = await axios.put(url, file.blob);
          if(statusText === "OK") {
            await uploadDoneAsync({fileId})
          }
          return {
            ...selectedLayer,
            fileId,
          };
        } else {
          return selectedLayer;
        }
      });
  
      const draftLayers = await Promise.all(uploadPromises);
  
      let draft = {
        band: 'original',
        pixelAlbumArtText: null,
        searchableTitle: null,
        persianTimelineTitle: null,
        persianOwnerTitle: null,
        ...data,
        layers: draftLayers,
        defaultTempo: tempo,
        duration: totalTime,
        timestamps: bares,
      };
  
      const saveResult = draft.draftId ? await editDraftAsync(draft) : await saveDraftAsync(draft);
      if (saveResult?.status === "OK") {
        draft.draftId = saveResult.draftId;
        setSelectedDraft(draft);
        if(tl) {
          await saveTlAsync(1);
          setRightTab('saveTlConfirm')
        } else {
          setRightTab('saveDraftConfirm')
        }
      } else {
        throw new Error('Error saving draft');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error during file upload or draft creation:', error);
    }
  };

  const bareBandi = () => {
    if(bareBandiType === "auto") {
      handleAutoBareBandi();
    }
    setBareBandiType(null);
    setRightTab(null);
  };

  return (
    <Box className="right-sidebar-wrapper">
      <Box className="action-wrapper">
        { loading ? (
          <Box className="loading">
            <Loading height={100} width={100} />
          </Box>
          ) : !layersIsActive ? null
          : (rightTab === "saveDraftConfirm" || rightTab === "saveTlConfirm") ? (
            <SaveProjectConfirm
              back={handleBackFromSaveProject}
              type={rightTab}
            />
          ) : rightTab ? (
            <Box className="parent-box">
              <Box className="parent-top-box">
                <div
                  className="parent-backSpace"
                  onClick={handleBack}
                >
                  <img src={BackRight} alt="" />
                </div>
                <div className="parent-title">
                  {!bareBandiType && (
                    <>
                      {rightTab === "saveDraft" && "Save Draft"}
                      {rightTab === "bareBandi" && "Bare Bandi"}
                      {rightTab === "createTL" && "Creat TimeLine"}
                      {rightTab === "artistName" && "Create TimeLine"}
                      {rightTab === "selectMoj" && "Create TimeLine"}
                    </>
                  )}
                  {bareBandiType === "auto" && "Auto Bare Bandi"}
                  {bareBandiType === "manual" && "Manual Bare Bandi"}
                </div>
              </Box>
              <Box className="parent-content">
                  {rightTab === "saveDraft" && (
                    <SaveDraft
                      draft={selectedDraft}
                      setDraft={setSelectedDraft}
                      submit={handleSaveDraft}
                    />
                  )}
                  {rightTab === "bareBandi" && (
                    <BareBandi
                      bareBandiType={bareBandiType}
                      setBareBandiType={setBareBandiType}
                      submit={bareBandi}
                    />
                  )}
                  {rightTab === "createTL" && (
                    <CreateTL
                      activeTab={rightTab}
                      setActiveTab={setRightTab}
                      draft={selectedDraft}
                      setDraft={setSelectedDraft} 
                    />
                  )}
                  {rightTab === "artistName" && (
                    <ArtistName
                      activeTab={rightTab}
                      setActiveTab={setRightTab}
                      draft={selectedDraft}
                      setDraft={setSelectedDraft} 
                    />
                  )}
                  {rightTab === "selectMoj" && (
                    <SelectMoj
                      draft={selectedDraft}
                      setDraft={setSelectedDraft}
                      submit={(e) => handleSaveDraft(e, true)}
                    />
                  )}
              </Box>
            </Box>
          ) : (
            <>
              {allLayerLock() ? (
                <Button
                  className="first-button"
                  disabled={!allLayerLock()}
                  onClick={() => {
                    setRightTab("createTL");
                  }}
                >
                  Creat TimeLine
                </Button>
              ) :
                (<Button
                  className="first-button"
                  onClick={() => setRightTab("saveDraft")}
                  disabled={!layersIsActive}
                >
                  Save Draft
                </Button>)
              }
              {bares.length ? (
                <Box className="first-button" style={{ overflow: "hidden" }} >
                  <BareShow
                    currentTime={time}
                    currentTrack={bareNumber()}
                    setCurrentTime={(currentTime) => {
                      setTime(currentTime)
                      setLayersUpdated(true)
                    }}
                    timestamps={bares}
                    defaultTempo={tempo}
                  />
                </Box>
              ) : (
                <Button
                  className="first-button"
                  onClick={() => {
                    setRightTab("bareBandi");
                  }}
                  disabled={!layersIsActive}
                >
                  Bare Bandi
                </Button>
              )
              }
            </>
          )
        }
      </Box>
      <Box className="play-wrapper">
        <VolumeKnob
          step={6}
          setValue={(val) => setTempo((pre) => Math.max(pre + val, 0))}
          active={bareBandiType}
          hasRotation={bareBandiType === "auto"}
          hasClick={bareBandiType === "manual"}
          handleClick={handleManualBareBandi}
        />
      </Box>
    </Box>
  );
};

export default RightSidebar;
